<template>
  <div id="view">
    <div class="image-section" id="img-1">
      <imageContainer class="image"
                      :imageName="'SZY_9685'"
                      :width="'100%'"
                      :height="'100vh'"></imageContainer>
      <h1 class="title">Dokumentumtár</h1>
      <div @click="goToSection('#docs')" class="arrow white">
        <arrow-svg></arrow-svg>
      </div>
    </div>
    <div id="docs" v-if="documentList.length > 0">
      <div class="decoration"></div>
      <div class="content">
        <h2>Letölthető kutatási anyagok</h2>
        <ul class="doclist">
          <li v-for="item in documentList">
            <h3>{{item.title}}</h3>
            <p v-if="item.description">{{item.description}}</p>
            <a :href="item.url" target="_blank">Letöltés</a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
  import imageContainer from './../components/imageContainer.vue'
  import arrowSvg from './../components/arrow.vue'
  import { scrollToSection } from '../utils'

  export default {
    name: 'openDays',
    components: {
      imageContainer,
      arrowSvg
    },
    computed: {
      documentList() {
          return this.$store.state.docs.doclist
      }
    },
    methods: {
      goToSection (selector) {
        return scrollToSection(selector)
      }
    },
    mounted() {
      this.$store.dispatch('docs/getOdDocs')
    }
  }
</script>

<style scoped>
  #view {
    position: relative;
  }

  .image-section {
    position: relative;
    width: 100%;
    font-size: 0;
  }

  .image {
    opacity: 0.8;
  }

  .title {
    position: absolute;
    left: 40px;
    bottom: 20vh;
    margin: 0 0 10px;
    font-size: 76px;
    color: var(--colorB);
    text-transform: uppercase;
    text-shadow: 2px 2px white;
  }


  .arrow {
    position: absolute;
    bottom: 7vh;
    left: calc(50% - 15px);
    width: 30px;
    height: 30px;
    padding: 5px;
    font-size: 36px;
    color: #fff;
    cursor: pointer;
    z-index: 2;
    border: 2px solid #fff;
    box-sizing: border-box;
  }

  #docs {
    position: relative;
    min-height: 100vh;
    padding: 80px 60px;
    border: 10px solid var(--colorB);
    text-align: left;
  }

  #docs h2 {
    position: absolute;
    min-height: 60px;
    height: auto;
    top: 0;
    left: 0;
    padding: 7px 60px 0;
    margin-top: 0;
    margin-bottom: 45px;
    background-color: var(--colorB);
    font-size: 28px;
    color: white;
    align-items: center;
  }


  .doclist {
    width: 80%;
    list-style: none;
    padding: 0;
  }

  .doclist h3 {
    font-size: 20px;
    font-weight: 600;
    margin: 0 0 10px;
    color: var(--colorA);
    text-transform: uppercase;
  }

  .doclist a {
    position: relative;
    color: var(--colorB);
    border-bottom: 1px solid var(--colorB);
  }

  .doclist li {
    margin-bottom: 40px;
  }

  .doclist li p {
    margin: 0 0 10px;
  }

  .decoration {
    position: absolute;
    width: calc(100vw / 7);
    height: 70vh;
    top: 0;
    right: 0;
    background-color: rgba(230, 61, 42, 0.76);
    z-index: -1;
  }

  @media (max-width: 768px) {
    .title {
      font-size: 7.2vh;
    }
  }

  @media (max-width: 600px) {
    .title {
      bottom: 20vh;
      left: 20px;
      font-size: 5vh;
    }

    .decoration {
      display: none;
    }
  }
</style>
